'use client'

import { createContext, useContext } from 'react'
import {
  type useRange,
  type UseRangeProps,
  type useRefinementList,
  type UseRefinementListProps,
} from 'react-instantsearch'

type ProductSearchRefinementContextValue =
  | {
      refinementList: ReturnType<typeof useRefinementList>
      refinementListOptions: UseRefinementListProps
    }
  | {
      refinementRange: ReturnType<typeof useRange>
      refinementRangeOptions: UseRangeProps
    }

export const ProductSearchRefinementContext = createContext<
  ProductSearchRefinementContextValue | undefined
>(undefined)

export const useProductSearchRefinementContext =
  (): ProductSearchRefinementContextValue => {
    const context = useContext(ProductSearchRefinementContext)

    if (!context) {
      throw new Error(
        'useProductSearchRefinementContext must be used within a "ProductSearchRefinementContext"',
      )
    }

    return context
  }
